import React from 'react';
import MembershipItem from './MembershipItem';
import useFetch from '../../hooks/useFetch';

import * as styles from './styles.module.css';

const Membership = () => {
  const {data = []} = useFetch(`${process.env.GATSBY_API_URL}/v1/consumer-membership-package/list`);

  return (
    <div>
      <div className={styles.list}>
        {data?.data
          ?.sort((a, b) => a.price - b.price)
          ?.map(item => (
            <MembershipItem key={item.id} {...item} />
          ))}
      </div>
      <p className={styles.des}>
        <ul>
          <li>Thời gian sử dụng: 24 tháng</li>
          <li>Áp dụng chung với chính sách Rentzy</li>
          <li>Áp dụng cho toàn bộ sản phẩm có sẵn</li>
          <li>Gói ưu đãi áp dụng cho tài khoản chính chủ, không hoàn và quy đổi thành tiền mặt.</li>
          <li>Các chương trình khuyến mãi không áp dụng đồng thời với nhau.</li>
        </ul>
      </p>
    </div>
  );
};

export default Membership;
